export default __webpack_public_path__ + "static/media/icon-right-white.60f2863c.svg";